<template>
  <div class="bg-white p-4">
    <div class="map-tip"></div>
    <template v-if="status !== 'DETAIL'">
      <a @click="handleClose" class="btn-close">
        <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
          <g fill-rule="evenodd">
            <rect height="1" rx=".5" transform="matrix(.70710678 .70710678 -.70710678 .70710678 10.010408 -4.146447)" width="16" x="2.010408" y="9.510408"/><rect height="1" rx=".5" transform="matrix(.70710678 -.70710678 .70710678 .70710678 -4.146447 10.010408)" width="16" x="2.010408" y="9.510408"/>
          </g>
        </svg>
      </a>
    </template>
    <template v-if="status == 'TENTATIVE'">
      <tentative />
    </template>
    <template v-else-if="status == 'APPROVE'">
      <approve />
    </template>
    <template v-else-if="status == 'RESERVED'">
      <reserved />
    </template>
    <template v-else>
      <busstop-info />
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BusstopInfo from '../AiBus/BusstopInfo'
import Tentative from '../AiBus/Tentative'
import Approve from '../AiBus/Approve'
import Reserved from '../AiBus/Reserved'
import Constants from '../../../constants'

export default {
  components: {
    BusstopInfo,
    Tentative,
    Approve,
    Reserved
  },
  computed: {
    ...mapGetters({
      status: 'reservation/getStatus'
    })
  },
  methods: {
    handleClose: function () {
      const ticket = this.$store.getters['user/getTicket']
      const env_key = process.env.VUE_APP_LINK_BASE_ENV || process.env.NODE_ENV
      location.href = Constants.LINK_BASE_URL_LIST[env_key] + '/?wallet=onDemand&serialNumber=' + ticket.serialNumber
    }
  }
}
</script>
